
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/builds/aschehoug/aschehoug-utdanning/shop-app/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as _91slug_93LBwJ_NN1WRjH91Ik7QtUWLedJW_ivs6XseWPlMJOTe0Meta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/produktkatalog/[slug].vue?macro=true";
import { default as takkyTPV_7aDLzB6hnc28XaMFOfe6f_NNtyOT0LlpdonuMEMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/takk.vue?macro=true";
import { default as component_45stubVvFUKYUeGAXxoSH1YVA92CCKHWrSpX1KYbZGphcI75g } from "/builds/aschehoug/aschehoug-utdanning/shop-app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
import { default as component_45stubVvFUKYUeGAXxoSH1YVA92CCKHWrSpX1KYbZGphcI75gMeta } from "/builds/aschehoug/aschehoug-utdanning/shop-app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
export default [
  {
    name: "login-confirm",
    path: "/logg-inn/bekreft",
    meta: {"middleware":["check-auth"]},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/logg-inn/bekreft.vue").then((m) => Object.assign(m.default, { __name: "login-confirm" }))
  },
  {
    name: "login-callback",
    path: "/login/callback",
    component: () => createClientPage(import.meta.client ? () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/login/callback.client.vue") : undefined).then((c) => Object.assign(c, { __name: "login-callback" }))
  },
  {
    name: "event",
    path: "/arrangementer/:event()",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/arrangementer/[event].vue").then((m) => Object.assign(m.default, { __name: "event" }))
  },
  {
    name: "article",
    path: "/artikler/:slug()",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/artikler/[slug].vue").then((m) => Object.assign(m.default, { __name: "article" }))
  },
  {
    name: "podcast",
    path: "/podkaster/:slug()",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/podkaster/[slug].vue").then((m) => Object.assign(m.default, { __name: "podcast" }))
  },
  {
    name: "product",
    path: "/produktkatalog/:slug()",
    meta: _91slug_93LBwJ_NN1WRjH91Ik7QtUWLedJW_ivs6XseWPlMJOTe0Meta || {},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/produktkatalog/[slug].vue").then((m) => Object.assign(m.default, { __name: "product" }))
  },
  {
    name: "events",
    path: "/arrangementer",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/arrangementer/index.vue").then((m) => Object.assign(m.default, { __name: "events" }))
  },
  {
    name: "articles",
    path: "/artikler",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/artikler/index.vue").then((m) => Object.assign(m.default, { __name: "articles" }))
  },
  {
    name: "brukerinvolvering",
    path: "/brukerinvolvering",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/brukerinvolvering.vue").then((m) => Object.assign(m.default, { __name: "brukerinvolvering" }))
  },
  {
    name: "handlekurv",
    path: "/handlekurv",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/handlekurv.vue").then((m) => Object.assign(m.default, { __name: "handlekurv" }))
  },
  {
    name: "informasjonskapsler",
    path: "/informasjonskapsler",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/informasjonskapsler.vue").then((m) => Object.assign(m.default, { __name: "informasjonskapsler" }))
  },
  {
    name: "kjopsbetingelser",
    path: "/kjopsbetingelser",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/kjopsbetingelser.vue").then((m) => Object.assign(m.default, { __name: "kjopsbetingelser" }))
  },
  {
    name: "kundeservice",
    path: "/kundeservice",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/kundeservice.vue").then((m) => Object.assign(m.default, { __name: "kundeservice" }))
  },
  {
    name: "login",
    path: "/logg-inn",
    meta: {"middleware":["check-auth"]},
    alias: ["/login"],
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/logg-inn/index.vue").then((m) => Object.assign(m.default, { __name: "login" }))
  },
  {
    name: "minside",
    path: "/minside",
    meta: {"middleware":["check-auth"]},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/minside.vue").then((m) => Object.assign(m.default, { __name: "minside" }))
  },
  {
    name: "nyhetsbrev",
    path: "/nyhetsbrev",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/nyhetsbrev.vue").then((m) => Object.assign(m.default, { __name: "nyhetsbrev" }))
  },
  {
    name: "om-aschehoug",
    path: "/om-aschehoug",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/om-aschehoug.vue").then((m) => Object.assign(m.default, { __name: "om-aschehoug" }))
  },
  {
    name: "personvern",
    path: "/personvern",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/personvern.vue").then((m) => Object.assign(m.default, { __name: "personvern" }))
  },
  {
    name: "podcasts",
    path: "/podkaster",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/podkaster/index.vue").then((m) => Object.assign(m.default, { __name: "podcasts" }))
  },
  {
    name: "products",
    path: "/produktkatalog",
    meta: {"middleware":["migrate-product-formats"]},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/produktkatalog/index.vue").then((m) => Object.assign(m.default, { __name: "products" }))
  },
  {
    name: "search",
    path: "/sok",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/sok.vue").then((m) => Object.assign(m.default, { __name: "search" }))
  },
  {
    name: "receipt",
    path: "/takk",
    meta: takkyTPV_7aDLzB6hnc28XaMFOfe6f_NNtyOT0LlpdonuMEMeta || {},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/takk.vue").then((m) => Object.assign(m.default, { __name: "receipt" }))
  },
  {
    name: "fallback",
    path: "/:slug(.*)*",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/[...slug].vue").then((m) => Object.assign(m.default, { __name: "fallback" }))
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/shop-app/app/pages/index.vue").then((m) => Object.assign(m.default, { __name: "index" }))
  },
  {
    name: component_45stubVvFUKYUeGAXxoSH1YVA92CCKHWrSpX1KYbZGphcI75gMeta?.name,
    path: "/login",
    component: Object.assign(component_45stubVvFUKYUeGAXxoSH1YVA92CCKHWrSpX1KYbZGphcI75g, { __name: component_45stubVvFUKYUeGAXxoSH1YVA92CCKHWrSpX1KYbZGphcI75gMeta?.name })
  },
  {
    name: component_45stubVvFUKYUeGAXxoSH1YVA92CCKHWrSpX1KYbZGphcI75gMeta?.name,
    path: "/login/bekreft",
    component: Object.assign(component_45stubVvFUKYUeGAXxoSH1YVA92CCKHWrSpX1KYbZGphcI75g, { __name: component_45stubVvFUKYUeGAXxoSH1YVA92CCKHWrSpX1KYbZGphcI75gMeta?.name })
  }
]